import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * ComingSoonComponent
 * Displays a "Coming Soon" placeholder page.
 * Supports optional query parameters: `title` and `helpText`
 * to customise the message shown to the user.
 */
@Component({
  selector: 'app-coming-soon',
  templateUrl: './comingsoon.component.html',
  styleUrls: ['./comingsoon.component.css'],
  standalone: false
})
export class ComingSoonComponent implements OnInit {

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    
   
  }
}
